export default __webpack_public_path__ + "static/media/marina.bda21060.jpg";